var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import styledMap from 'styled-map';
import { color, icon } from '../constants';
var svgAttrs = {
    viewBox: '0 0 24 24',
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};
var Wrapper = styled.svg(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  ", "\n  width: ", ";\n  height: ", ";\n"], ["\n  display: inline-block;\n  ",
    "\n  width: ",
    ";\n  height: ",
    ";\n"])), function (props) {
    var _a;
    var paint = (_a = props.fillColor) !== null && _a !== void 0 ? _a : color.theme.icon.subdued;
    return props.outline !== undefined && props.outline
        ? "fill: none; stroke: " + paint + ";"
        : "fill: " + paint + "; stroke: none;";
}, styledMap(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    tiny: ", ";\n    small: ", ";\n    large: ", ";\n    default: ", ";\n  "], ["\n    tiny: ", ";\n    small: ", ";\n    large: ", ";\n    default: ", ";\n  "])), icon.size.tiny, icon.size.small, icon.size.large, icon.size.default), styledMap(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    tiny: ", ";\n    small: ", ";\n    large: ", ";\n    default: ", ";\n  "], ["\n    tiny: ", ";\n    small: ", ";\n    large: ", ";\n    default: ", ";\n  "])), icon.size.tiny, icon.size.small, icon.size.large, icon.size.default));
export var Svg = function (props) {
    return React.createElement(Wrapper, __assign({}, svgAttrs, props));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Svg.js.map